import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import "../book.css";

import CodeNavigator from "./CodeNavigator";
import HtmlLiveProvider from "../editors/HtmlLiveProvider";
import HtmlLiveEditor from "../editors/HtmlLiveEditor";
import HtmlLivePreview from "../editors/HtmlLivePreview";
import CssLiveEditor from "../editors/CssLiveEditor";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.margins.lg};
`;

const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExerciseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Navigation = styled.div`
  width: 100%;
  display: flex;
`;

const Panel = styled.div`
  width: 100%;
  border-radius: ${props => props.theme.radius.xs};
`;

const ResetPanel = Panel.extend`
  display: flex;
  padding: 0;
  padding-bottom: ${props => props.theme.margins.sm};
  justify-content: flex-end;
`;

const CodingPanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const CodePanel = styled.div`
  position: relative;
  flex-basis: 49.5%;
  align-items: stretch;
  max-height: 400px;
  border-radius: ${props => props.theme.radius.xs};
  padding: ${props => props.theme.margins.md};
  background: ${props => props.theme.colors.primaryDark};
  overflow-x: scroll;
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.4);
  &:before {
    position: absolute;
    top: 5px;
    right: 5px;
    background: ${props => props.theme.colors.purple};
    color: ${props => props.theme.colors.transparent75};
    padding: 1px 3px;
    content: "html";
    font-size: ${props => props.theme.fontSizes.xs};
    z-index: 1000;
  }
`;

const CssPanel = styled.div`
  position: relative;
  flex-basis: 49.5%;
  align-items: stretch;
  max-height: 400px;
  border-radius: ${props => props.theme.radius.xs};
  padding: ${props => props.theme.margins.md};
  background: ${props => props.theme.colors.primaryDark};
  overflow-x: scroll;
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.4);
  &:before {
    position: absolute;
    top: 5px;
    right: 5px;
    background: ${props => props.theme.colors.purple};
    color: ${props => props.theme.colors.transparent75};
    padding: 1px 3px;
    content: "css";
    font-size: ${props => props.theme.fontSizes.xs};
    z-index: 1000;
  }
`;

const ResultPanel = Panel.extend`
  background: white;
  border: 1px solid #eee;
  overflow-x: scroll;
  box-shadow: 0 40px 50px -30px rgba(0, 0, 0, 0.2);
  min-height: 300px;
  max-height: 600px;
  margin-bottom: 0.5rem;
`;

class HtmlWithCssCodeBlock extends Component {
  static propTypes = {
    blockNumber: PropTypes.string.isRequired
  };

  render() {
    const { blockNumber, codeUser, cssUser, activeChapterId, codeId } = this.props;

    return (
      <Wrapper data-blocknumber={blockNumber} className='block'>
        <MainPanel>

          <Navigation>
            <ResetPanel>
              <CodeNavigator activeChapterId={activeChapterId} codeId={codeId}/>
            </ResetPanel>
          </Navigation>

          <HtmlLiveProvider code={codeUser} css={cssUser} codeId={codeId}>
            <ExerciseWrapper>

              <ResultPanel>
                <HtmlLivePreview />
              </ResultPanel>

              <CodingPanel className='coding-panel'>
                <CodePanel>
                  <HtmlLiveEditor />
                </CodePanel>

                <CssPanel>
                  <CssLiveEditor />
                </CssPanel>
              </CodingPanel>

            </ExerciseWrapper>
          </HtmlLiveProvider>

        </MainPanel>
      </Wrapper>
    );
  }
}

export default HtmlWithCssCodeBlock;



// WEBPACK FOOTER //
// ./src/book/blocks/HtmlWithCssCodeBlock.js